import { Invitation, PartyModel } from "../types";
import AuthenticationResponse from "../api/responses/AuthenticationResponse";

export const getFacebookAvatar = (userId: string): string => {
  return `https://graph.facebook.com/${userId}/picture?height=1000&width=1000`;
};

export const getSortedMyPartiesByDate = (
  myParites: PartyModel[]
): PartyModel[] => {
  return myParites.sort(function (objA: PartyModel, objB: PartyModel) {
    const dateA = new Date(objA.party.partyDate);
    const dateB = new Date(objB.party.partyDate);

    return dateA.getTime() - dateB.getTime();
  });
};

export const getOrderedInvitations = (
  userInfo: AuthenticationResponse,
  invitations: Invitation[]
): Invitation[] => {
  if (!userInfo) {
    return invitations;
  } else {
    const index = invitations.findIndex(
      (invitation) =>
        invitation.firstName === userInfo.firstName &&
        invitation.lastName === userInfo.lastName
    );

    const element = invitations.splice(index, 1)[0];
    invitations.unshift(element);

    return invitations;
  }
};

export const filterGroupsByMinimumAge = (
  groups: PartyModel[],
  minimumAge: number | ""
): PartyModel[] => {
  if (minimumAge === "") {
    return groups;
  }

  return groups.filter((group) => {
    const ages = group.invitations
      .map((invitation) => invitation.age)
      .filter((age) => typeof age === "number" && !Number.isNaN(age));

    if (ages.length === 0) {
      return false;
    }

    const groupMinimumAge = Math.min(...ages);
    return groupMinimumAge >= minimumAge;
  });
};
